/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable arrow-body-style */
import React, { useState } from 'react';
import { history, useIntl, useParams } from 'umi';
import { notification } from 'tea-component';
import useConstants from "@/pages/dashboard/pages/subscribe/_config/constant";
import { saveSubscribeSetting } from '@/pages/dashboard/services/substribe';
import ConfirmModal from '../ConfirmModal';

type SubscribeHandleType = "unsubscribe" | "pushAgain" | "resubscribe" | "delete"

export default ({ record, gameCode, refreshTable, subscribeRequestOptions, setTableLoading }: any) => {
  const { formatMessage } = useIntl();
  // 拼接跳转路径前缀.
  const { gamecode: id, type }: any = useParams() || {};
  const url = `/dashboard/${type}/${id}`;

  const { SETTING_FIELDS } = useConstants();
  // 再次发送弹窗
  const [sendVisible, setSendVisible] = useState(false);
  // 退订弹窗
  const [unsubscribeVisible, setUnsubscribeVisible] = useState(false);

  // 退订或再次发送弹窗展示的推送标题
  const [pushTitle, setPushTitle] = useState("");
  // 退订弹窗
  const [deleteVisible, setDeleteVisible] = useState(false);

  const { subscribe_title, subscribe_id, subscribe_desc, receiver_account, send_type, start_date, end_date, frequency_type, frequency_time, frequency_interval, subscribe_name, subscribe_content, receiver_user_ids, is_outside_user, viewport_width } = record;

  const handleSubscribe = (type: SubscribeHandleType) => {
    setTableLoading();
    const option = subscribeRequestOptions[type];
    const errorCode = formatMessage({ id: "error_code_error_code" });
    const succ = formatMessage({ id: "subscribe_manager_success" });
    const fail = formatMessage({ id: "subscribe_manager_fail" });

    // 修复老版本遗留问题，userlist信息比较敏感，而且本来不需要也不能传给后端
    const recordParams = JSON.parse(JSON.stringify(record));
    recordParams?.user_list && delete recordParams?.user_list;

    saveSubscribeSetting({
      ...recordParams,
      ...option?.params
    }).then(() => {
      // className: "downDataBox" 可以让多个通知的时候竖排显示，不是横排显示
      notification.success({
        className: "downDataBox",
        duration: 1000,
        description: `【${record?.subscribe_title}】${option?.name}${succ}！`
      });
    }).catch(e => {
      console.log(`${option?.name}请求错误`, e);
      notification.error({
        className: "downDataBox",
        duration: 1000,
        description: `【${record?.subscribe_title}】${option?.name}${fail}！${e?.code ?? `${errorCode}：${e?.code}`}`
      });
    }).finally(() => {
      refreshTable();
    });
  };

  const jumpSubscriptSetting = () => {
    history.push({
      pathname: `${url}/subscribe/subscribeSetting`,
      query: {
        formValue: JSON.stringify({
          id: subscribe_id,
          [SETTING_FIELDS.TITLE]: subscribe_title,
          [SETTING_FIELDS.CONTENT]: subscribe_desc,
          [SETTING_FIELDS.RECEIVERS]: is_outside_user === 1 ? receiver_account.replaceAll(',', ';') : receiver_user_ids.split(','),
          [SETTING_FIELDS.WAYS]: send_type.split(','),
          [SETTING_FIELDS.FREQUENCY]: {
            type: frequency_type,
            frequency_time,
            frequency_interval: frequency_type == '2' ? frequency_interval : frequency_interval.split(','),
          },
          [SETTING_FIELDS.CYCLE]: [start_date.substring(0, 10), end_date.substring(0, 10)],
          [SETTING_FIELDS.SENDOUTEMAIL]: is_outside_user === 1 ? 'send' : 'no',
          [SETTING_FIELDS.VIEWPORT_WIDTH]: viewport_width ? viewport_width : ''

        }),
        backUrl: `${url}/subscribe/subscribeManage`,
        gameCode: gameCode,
        pageName: subscribe_name,
        subscribeContent: subscribe_content,
        pageType: record.page_type,
        isOutsideUser: is_outside_user,
        isEdit: 'edit'
      },
    });
  };

  // 编辑
  const renderEdit = () => {
    return <span className='table-flex-text' onClick={jumpSubscriptSetting}>{formatMessage({ id: "common_edit" })}</span>;
  };

  // 退订
  const renderUnsubscribe = () => {
    return <span className='table-flex-text' onClick={() => {
      setPushTitle(record["subscribe_title"]);
      setUnsubscribeVisible(true);
    }}>{formatMessage({ id: "subscribe_manager_handle_unsubscribe" })}</span>;
  };

  // 再次发送
  const rendeResend = () => {
    return <span className='table-flex-text' onClick={() => {
      setPushTitle(record["subscribe_title"]);
      setSendVisible(true);
    }}>{formatMessage({ id: "subscribe_manager_handle_push_again" })}</span>;
  };

  // 重订
  const renderResubscribe = () => {
    return <span
      className='table-flex-text'
      onClick={() => {
        jumpSubscriptSetting();
      }}>{formatMessage({ id: 'subscribe_manager_handle_resubscribe' })}</span>;
  };

  // 发送记录
  const renderHistory = () => {
    return <span className='table-flex-text' onClick={() => {
      history.push({
        pathname: `${url}/subscribe/subscribeRecord`,
        query: {
          id: subscribe_id,
          title: subscribe_title,
          frequency_interval: record.frequency_interval,
          frequency_time: record.frequency_time,
          frequency_type: record.frequency_type,
        }
      }
      );
    }}>{formatMessage({ id: "subscribe_manager_handle_push_report" })}</span>;
  };

  // 删除
  const renderDelete = () => {
    return <span
      className='table-flex-text'
      onClick={() => {
        setPushTitle(record["subscribe_title"]);
        setDeleteVisible(true);
      }}>{formatMessage({ id: 'common_delete' })}</span>;
  };

  // 订阅者操作
  const rendersubscribeOptBtn = () => {
    const isOutEmail = is_outside_user === 1;
    if (record?.["subscribe_status"] === 1) {
      return <>
        {renderEdit()}
        {/* 和廖安核对后，外部邮件不展示退订 */}
        {!isOutEmail && renderUnsubscribe()}
        {rendeResend()}
        {/* {renderResubscribe()} */}
        {renderHistory()}
        {renderDelete()}
      </>;
    }
    if (record?.["subscribe_status"] === 0 || record["subscribe_status"] === 2) {
      return <>
        {renderResubscribe()}
        {renderHistory()}
        {renderDelete()}
      </>;
    }
    return <>
      {renderResubscribe()}
      {renderHistory()}
    </>;

  };

  // 收件人操作
  const renderReceiverOptBtn = () => {
    const isOutEmail = is_outside_user === 1;
    {/* 和廖安核对后，外部邮件也不展示退订 */ }
    if (record?.["subscribe_status"] === 1 && !isOutEmail) {
      return <>
        {renderUnsubscribe()}
      </>;
    } 
    return <>
        -
    </>;
  };


  return (<>
    {/* '订阅状态, 0:未订阅（退订） 1:已订阅（订阅中） 2:订阅完成' 和后端核对后，老版本逻辑0和2展示的操作一致，新版本正沟通中 */}
    <div className='table-flex'>
      {
        record?.["own_role"] === 'subscribe_role' ? rendersubscribeOptBtn() : renderReceiverOptBtn()
      }
    </div>

    <ConfirmModal
      visible={sendVisible}
      title={formatMessage({ id: "subscribe_manager_handle_push_again" })}
      desc={formatMessage({ id: "subscribe_manager_handle_is_push_again" })}
      name={pushTitle}
      onClick={() => {
        // 再次发送
        handleSubscribe("pushAgain");
        setSendVisible(false);
      }}
      onClose={() => setSendVisible(false)}
    />

    <ConfirmModal
      visible={unsubscribeVisible}
      onClick={() => {
        // 退订
        handleSubscribe("unsubscribe");
        // 需求上点击确认按钮后, 关闭弹窗
        setUnsubscribeVisible(false);
      }}
      onClose={() => setUnsubscribeVisible(false)}
      title={formatMessage({ id: "subscribe_manager_handle_unsubscribe" })}
      desc={formatMessage({ id: "subscribe_manager_handle_is_unsubscribe" })}
      name={pushTitle}
    />

    <ConfirmModal
      visible={deleteVisible}
      onClick={() => {
        // 删除
        handleSubscribe("delete");
        // 需求上点击确认按钮后, 关闭弹窗
        setDeleteVisible(false);
      }}
      onClose={() => setDeleteVisible(false)}
      title={formatMessage({ id: "common_delete" })}
      desc={formatMessage({ id: "subscribe_manager_handle_is_delete" }, { name: <span className='dbd_subscribe_delete_name'>【{pushTitle}】</span> })}
    />
  </>
  );
};